<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card">
      <vs-list>
        <vs-list-header title="Dictation을 통해 문장 듣기 능력을 향상시킵니다." icon-pack="feather" icon="icon-info"></vs-list-header>
        <vs-list-item class="msg-grp-container">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-item>
      </vs-list>
      <div class="lg:p-8 md:p-6 sm:p-4 p-4 rounded-lg mb-base text-center">
        <vs-row vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
            <component 
              v-model="item.model" 
              :ref="item.ref" 
              @onEnter="onChildEnter"
              @onBack="onChildBack" 
              :key="index" 
              v-for="(item, index) in sentenceComponentList" 
              :is="item.input" 
              v-bind="item.props"/>
        </vs-row>
      </div>  

      <div v-show="!isShowTranslation" class="text-center mb-8"><a href="#" @click="showTranslation()"><h5 class="text-success">[해석보기]</h5></a> </div>
      <div v-show="isShowTranslation" class="text-center mb-8"><h5 class="text-success">{{ content.translation }}</h5></div>

      <div class="text-center" >
        <audio ref="audioPlayer" 
            controls 
            loop
            v-on:ended="audioFinish" 
            controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>
      </div>
    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" @onHint="onHint" ></top-button-bar>
  </div>

</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'
import DictationWordInput      from './DictationWordInput.vue'
import DictationWordLabel      from './DictationWordLabel.vue'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar,
    DictationWordInput,
    DictationWordLabel
  },
  data () {
    return {
      sentenceComponentList: [],
      dictationInputList: [],
      isStart: false,
      contentList: [],
      contentsLen: 0,
      hint: true,
      contentIndex: 0,
      finished: false,
      usedHintCount: 0,
      retryCount: 0,
      isShowTranslation: false
    }
  },
  watch: {
    
  },
  computed: {
    audioPlayer () {
      return this.$refs.audioPlayer
    },
    content () {
      return this.contentList[this.contentIndex]
    },
    sentenceWords () {
      return this.content.sentence.split(' ')
    },
    dictationWords () {
      return this.content.dictation.split(' ')
    },
    dictation () {
      return this.content.dictation
    }
  },
  methods: {
    onReload () {
      this.hint = false
      this.isStart = false
      this.contentIndex = 0
      this.usedHintCount = 0
      this.studyResult = []
      this.retryCount = 0
      this.isShowTranslation = false
      this.resetComponents()
      this.startAlert()
    },
    showTranslation () {
      this.isShowTranslation = true
    },
    audioFinish () {
    },
    onStart () {
      this.isStart = true
      this.configSentence()
    },
    onHint () {
      if (this.usedHintCount >= this.hintCount) {
        this.finishHintDlg()
      } else {
        this.usedHintCount++
        for (let i = 0; i < this.dictationInputList.length; i++) {
          this.dictationInputList[i].props.hint = true
        }
      }
    },
    resetComponents () {
      this.sentenceComponentList = []
      this.dictationInputList = []
    },
    startAlert () {
      this.startStudyDlg('Dictation을 통해 문장 듣기 능력을 향상시킵니다.')
    },
    acceptAlert () {
      this.onStart()
    },
    replaceSymbol (value) {
      return value.replace('.', '').replace('?', '').replace('!', '').replace(',', '')
    },
    configSentence () {
      
      let inputIndex = 0
      for (let i = 0; i < this.dictationWords.length; i++) {
        if (this.dictationWords[i].substring(0, 1) !== '_') {
          const conf = {
            data: this.sentenceWords[i]
          }
          this.sentenceComponentList.push({ input: DictationWordLabel, props: conf })
        } else {  
          
          // 마침표, 물음표 등 특수기호 처리
          const sen = this.sentenceWords[i]
          let hasSymbol = false
          const symbol = sen.substring(sen.length - 1, sen.length)
          if (symbol === '.' || symbol === '?' || symbol === '!' || symbol === ',') {
            hasSymbol = true
          }

          const conf = {
            hintValue: this.replaceSymbol(this.sentenceWords[i]),
            hint: true,
            index: inputIndex
          }
          const comp = {
            input: DictationWordInput, 
            props: conf, 
            model: '',
            value: '',
            answer:  this.replaceSymbol(this.sentenceWords[i]),
            ref: `input_${inputIndex}`
          }
          this.sentenceComponentList.push(comp)  
          this.dictationInputList.push(comp)
            
          if (hasSymbol) {
            this.sentenceComponentList.push({ input: DictationWordLabel, props: {data: symbol}})
          }

          inputIndex++
        }
      }

      this.audioPlayer.src = this.content.audio
      this.audioPlayer.play()

      setTimeout(function () {
        this.$refs['input_0'][0].focus()
      }.bind(this), 500)

    },
    onChildEnter (index) {
      
      if (this.dictationInputList[index].model.length === 0) {
        return
      }

      if (index < this.dictationInputList.length - 1) {
        this.$refs[`input_${  index + 1  }`][0].focus()
      } else { 
        
        let correct = true
        for (let i = 0; i < this.dictationInputList.length; i++) {
          console.log(this.dictationInputList[i].model)
          console.log(this.dictationInputList[i].answer)
          if (this.dictationInputList[i].model !== this.dictationInputList[i].answer) {
            correct = false
            break
          }
        }

        if (correct) {
          
          this.addResult(this.dictation, this.dictationInputList[index].answer, this.dictationInputList[index].model)

          this.correct()
        } else {
          
          this.inCorrect()

          this.retryCount++
          if (this.retryCount < this.retry) {
            setTimeout(function () {
              for (let i = 0; i < this.dictationInputList.length; i++) {
                this.dictationInputList[i].model = ''
              }
            }.bind(this), 1500)
            return
          }

          this.addResult(this.dictation, this.dictationInputList[index].answer, this.dictationInputList[index].model) 
        }

        this.audioPlayer.pause()

        if (this.contentIndex < this.contentsLen - 1) {
          setTimeout(function () {
            this.retryCount = 0
            this.isShowTranslation = false
            this.contentIndex++
            this.resetComponents()
            this.configSentence()
          }.bind(this), 1500)
        } else {
          this.onComplete()   
        }    
      }
    },
    onChildBack (index) {
      if (index !== 0 && this.dictationInputList[index].model.length === 0) {
        this.$refs[`input_${  index - 1  }`][0].focus()
      }
    }
  },
  created () {

    const contentJson = JSON.parse(this.sourceContent.contentBody)
    for (let i = 0; i < contentJson.sentence.length; i++) {
      const content = {
        sentence: contentJson.sentence[i],
        translation: contentJson.translation[i],
        dictation: contentJson.dictation[i],
        hint: '',
        audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1)
      } 
      this.contentList.push(content)
    }

    // this.contentList = [
    //   {
    //     sentence: 'Let\'s slide .',
    //     translation: '미끄럼틀을 타자.',
    //     dictation: 'Let\'s _____ .',
    //     hint: 'slide',
    //     audio: 'http://54.180.116.80:8080/contents/SP/L01/B01/U01/W01/SPL01B03U01W010_01.mp3'
    //   },
    //   {
    //     sentence: 'Are you ready ?',
    //     translation: '준비됐니?',
    //     dictation: 'Are you _____ ?',
    //     hint: 'ready',
    //     audio: 'http://54.180.116.80:8080/contents/SP/L01/B01/U01/W01/SPL01B03U01W010_02.mp3'
    //   },
    //   {
    //     sentence: 'Who is next ?',
    //     translation: '다음은 누구지?',
    //     dictation: '___ is next ?',
    //     hint: 'Who',
    //     audio: 'http://54.180.116.80:8080/contents/SP/L01/B01/U01/W01/SPL01B03U01W010_03.mp3'
    //   },
    //   {
    //     sentence: 'It is your turn .',
    //     translation: '너의 차례야.',
    //     dictation: 'It is your ____ .',
    //     hint: 'turn',
    //     audio: 'http://54.180.116.80:8080/contents/SP/L01/B01/U01/W01/SPL01B03U01W010_04.mp3'
    //   }
      
    // ]
    this.contentsLen = this.contentList.length
    this.startAlert()
  },
  mounted () {
  }
}

</script>
